module.exports = __webpack_public_path__ + "static/media/sup.76a9c1c4.png";